import type { JSX } from 'react';

import type { ErrorHandlerProps } from 'src/app/pages/topic/pageContext';

export function TopicErrorHandler({ context: { error } }: ErrorHandlerProps): JSX.Element {
	throw new Error(`Failed to retrieve data for topic page (error: ${error})`);
}
